import { isValidNumber } from '../../Library/Helper';
import { CInvoicingPriceUnitTaxType } from '../types';
import { CInvoicingPriceWithTax } from './CInvoicingPriceWithTax';

export class CInvoicingPriceUnitTax implements CInvoicingPriceUnitTaxType {
  constructor(json: CInvoicingPriceUnitTaxType) {
    Object.assign(this, json);
  }

  pricePerUnit: number;

  unitCount: number;

  taxPercent: number;

  toInvoicingPriceWithTax = (): CInvoicingPriceWithTax => {
    const { pricePerUnit, unitCount, taxPercent } = this;
    const withoutTax = pricePerUnit * unitCount;
    const withTax = isValidNumber(taxPercent) ? withoutTax * (1 + taxPercent / 100) : withoutTax;
    return new CInvoicingPriceWithTax({
      withTax,
      withoutTax,
      taxAmount: (withoutTax * taxPercent) / 100,
    });
  };
}
